import { ApplicationElement, html } from '@effectivastudio/lit-components';

import style from './style.lit.css';

/**
 * Wrapper component for many types of content (usually lists).
 *
 * @prop horizontal - Main content will have horizontal layout if set to true, otherwise vertical
 * @prop overflow - Main content will have scroll overflow if set to true, otherwise it will be hidden
 * @prop gap - The gap between main content items (options: /, sm, md, lg, xl) defaults to 0
 *
 * @slot default - Main slot for list content
 * @slot left - Has subtitle text content
 * @slot right - Button/link
 *
 * @cssprop --gap - The gap between main content items
 * @cssprop --background - Component background
 * @cssprop --max-height - For limiting main slot height. Can activate overflow scroll in combination with overflow attribute
 */

export default class List extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    gap: { type: String, reflect: true },
    horizontal: { type: Boolean, reflect: true },
    overflow: { type: Boolean, reflect: true },
  };

  render() {
    return html`
      <div class="section">
        <header>
          <slot name="left"></slot>
          <slot name="right"></slot>
        </header>
        <slot></slot>
      </div>
    `;
  }
}

customElements.get('xs-list') || customElements.define('xs-list', List);
